import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-400f6168"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "footer" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { nextTick, ref } from 'vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ElMessageBox } from 'element-plus/es'
import { editPageData, getListData } from '@/service/main/system'
import { md5 } from 'js-md5'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import JsonEditor from 'vue3-ts-jsoneditor'

const editUrl = '/main/themeTable/saveColumn'


export default /*#__PURE__*/_defineComponent({
  __name: 'themeTable',
  setup(__props) {

initEmptyParam()

const modalTitle = ref('创建表')

const newCb = () => {
  modalTitle.value = '创建表'
  defaultInfo.value.isChild = 0
}

const editCb = () => {
  modalTitle.value = '编辑表'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const mainTables = ref([])
const loadTables = async () => {
  mainTables.value = await getListData('/main/themeTable/listMain', {})
  const tableItem = modalConfig.formItems.find(
    (item) => item.field == 'mainTableId'
  )
  tableItem!.options = mainTables.value.map((item: any) => {
    return { title: item.tableComment, value: item.id }
  })
}
loadTables()
// -------- 列维护
const columnDialog = ref(false)
const activeTab = ref('create')
const tags: any = ref([])
const columns: any = ref([
  {
    title: '序号',
    dataIndex: 'columnSort',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    fixed: 'left'
  },
  {
    title: '字段中文名',
    dataIndex: 'columnComment',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    fixed: 'left'
  },
  {
    title: '字段名',
    dataIndex: 'columnName',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    fixed: 'left'
  },
  {
    title: '字段类型',
    dataIndex: 'columnType',
    type: 'columnType',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    fixed: 'left'
  },
  {
    title: '字段长度',
    dataIndex: 'columnLength',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '是否可以为空',
    dataIndex: 'nullable',
    type: 'isOrNot',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '是否业务字段',
    dataIndex: 'isBusinessColumn',
    type: 'isOrNot',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '是否作为检索条件',
    dataIndex: 'isQuery',
    type: 'isOrNot',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '是否自增',
    dataIndex: 'autoIncrement',
    type: 'isOrNot',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '是否列表展示',
    dataIndex: 'isList',
    type: 'isOrNot',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '是否主键',
    dataIndex: 'isPrimary',
    type: 'isOrNot',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '默认值',
    dataIndex: 'defaultValue',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '可编辑角色',
    dataIndex: 'oprRoles',
    type: 'oprRoles',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '组件类型',
    dataIndex: 'component',
    type: 'component',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '组件参数',
    dataIndex: 'componentOptions',
    type: 'jsonEditor',
    autoHeight: true,
    editable: false,
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '字段宽度',
    dataIndex: 'columnWidth',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  },
  {
    title: '数据格式',
    dataIndex: 'columnFormat',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 140,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter()
  }
])
const dataList: any = ref([])
const currentTable: any = ref({})
const handleEditColumns = (item: any) => {
  console.log(item)
  columnDialog.value = true
  currentTable.value = item
  loadColumns(item)
}

const loadColumns = (item: any) => {
  getListData(`/main/themeTable/loadColumns/${item.id}`, {}).then((res) => {
    dataList.value = res
    dataList.value.forEach((row: any) => {
      row.key = row.id
    })
    tags.value = res.map((row: any) => {
      return {
        name: row.columnComment,
        key: item.id,
        closable: row.isBusinessColumn == 0 ? false : true,
        type: row.isBusinessColumn == 0 ? 'info' : 'success'
      }
    })
    count.value = res.length
  })
}

const handleCreateTable = (item: any) => {
  editPageData(`/main/themeTable/createTable/${item.id}`, {}).then((res) => {
    ElMessage.success({
      message: '创建成功',
      type: 'success',
      duration: 3 * 1000
    })
    loadTables()
  })
}

const inputValue = ref('')
const inputVisible = ref(false)
const InputRef = ref<any>()

const handleClose = (tag: any) => {
  tags.value.splice(
    tags.value.findIndex((item: any) => item.name == tag.name),
    1
  )
}

const addColumn = () => {
  inputVisible.value = true
  nextTick(() => {
    InputRef.value!.input!.focus()
  })
}
const count = ref(0)
const handleInputConfirm = () => {
  if (inputValue.value) {
    const newData: any = {
      columnType: 'varchar',
      columnLength: '255',
      isNull: 1,
      isBusinessColumn: 1,
      isSearch: 0,
      isList: 1,
      isEdit: 1,
      component: 'el-input',
      componentOptions: '',
      dataFormat: '',
      columnComment: inputValue.value
    }
    editPageData(
      `/main/themeTable/addColumn/${currentTable.value.id}`,
      newData
    ).then((res) => {
      loadColumns(currentTable.value)
    })
  }
  inputVisible.value = false
  inputValue.value = ''
}

const handleTabClick = (tab: any, event: Event) => {}

const nextStep = () => {
  activeTab.value = 'config'
}

const formatMainTableId = (id: any) => {
  const item: any = mainTables.value.find((item: any) => item.id == id)
  return item ? item.tableComment : ''
}

const formatIsOrNot = (column: any, record: any) => {
  if (record[column.dataIndex] == 0) {
    return '否'
  } else {
    return '是'
  }
}

const formatRoles = (value: any) => {
  if (value) {
    const item: any = oprRoles.value.find((item: any) => item.value == value)
    return item ? item.label : ''
  } else {
    return value
  }
}

const translateByOneKey = () => {
  dataList.value.forEach((obj: any, index: number) => {
    if (!obj.columnName) {
      translateCnToEn(obj.columnComment).then((res: any) => {
        obj.columnName = res
        dataList.value = [...dataList.value]
      })
    }
  })
}

const translateCnToEn = async (data: string): Promise<any> => {
  const appid = '20241106002195964'
  const key = 'R0XzsJ_eHfXBcPvTPs8w'
  const salt = new Date().getTime()
  const query = data
  const from = 'zh'
  const to = 'en'
  const str1 = appid + query + salt + key
  const sign = md5(str1)

  try {
    const response: any = await axios.get('/baidu/trans/vip/translate', {
      params: {
        q: query,
        appid: appid,
        salt: salt,
        from: from,
        to: to,
        sign: sign
      }
    })

    console.log(response.data)
    return response.data.trans_result[0].dst
  } catch (error) {
    console.error('翻译错误:', error)
  }
}

const preStep = () => {
  activeTab.value = 'create'
}

const submitColumns = () => {
  nextStep()
  currentTable.value.dataList = dataList.value
  let pageUrl = `/main/themeTable/submitColumns/${currentTable.value.id}`
  editPageData(pageUrl, currentTable.value).then((res) => {
    console.log(res)
  })
}

const cancelAndClose = () => {
  columnDialog.value = false
}

function getValueSetter() {
  return ({ record, column, row, newValue, oldValue }: any) => {
    let stack = new Error().stack
    if (stack!.indexOf('handleKeyDown') != -1) {
      return true
    }
    let field = column.dataIndex
    let body: any = {}
    body[field] = newValue
    body['id'] = record.id
    console.log(record.id)
    editPageData(editUrl, body).then(() => {
      loadColumns(currentTable.value)
    })
    return true
  }
}

const oprRoles = ref([])
const getRoleList = async () => {
  let roleData = await getListData('/main/role/listAll', {})
  oprRoles.value = roleData.list.map((item: any) => {
    return { label: item.displayName, value: item.id }
  })
}

getRoleList()

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const jsonEditorDialog = ref(false)
const jsonEditorRef = ref(null)
const currentJsonData = ref({})
const currentColumn: any = ref({})

const openJsonEditor = (item: any) => {
  console.log(item)
  jsonEditorDialog.value = true
  if(item.componentOptions) {
    currentJsonData.value = JSON.parse(item.componentOptions)
  } else {
    currentJsonData.value = {}
  }
  currentColumn.value = item
}

const handleSave = async (e: Event) => {
  let body: any = {}
  if (typeof currentJsonData.value == 'string') {
    body['componentOptions'] = currentJsonData.value
  } else {
    body['componentOptions'] = JSON.stringify(currentJsonData.value)
  }
  body['id'] = currentColumn.value.id
  editPageData(editUrl, body).then(() => {
    loadColumns(currentTable.value)
    jsonEditorDialog.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_s_table = _resolveComponent("s-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "themeTable",
      deleteTip: "确认删除此表吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onColumnEdit: handleEditColumns,
      onCreateTable: handleCreateTable
    }, {
      isPublish: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.isPublish == 0 ? '未发布' : '已发布'), 1)
      ]),
      isChild: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.isChild == 0 ? '否' : '是'), 1)
      ]),
      mainTableId: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(formatMainTableId(scope.row.mainTableId)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      validOtherInfo: () => true,
      pageName: "themeTable"
    }, null, 8, ["defaultInfo", "modalConfig", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: columnDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((columnDialog).value = $event)),
      title: "",
      width: "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
          class: "column-tabs",
          onTabClick: handleTabClick,
          "before-leave": _ctx.checkTags
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "创建列",
              name: "create"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: tag.key,
                      closable: tag.closable,
                      type: tag.type,
                      onClose: ($event: any) => (handleClose(tag))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["closable", "type", "onClose"]))
                  }), 128)),
                  (inputVisible.value)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        ref_key: "InputRef",
                        ref: InputRef,
                        modelValue: inputValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
                        class: "w-20",
                        size: "small",
                        onKeyup: _withKeys(handleInputConfirm, ["enter"]),
                        onBlur: handleInputConfirm
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "button-new-tag",
                        size: "small",
                        onClick: addColumn
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 添加字段 ")
                        ]),
                        _: 1
                      }))
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: submitColumns
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提交")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "default",
                    onClick: cancelAndClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "列配置",
              name: "config"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_s_table, {
                    bordered: "",
                    "data-source": dataList.value,
                    columns: columns.value,
                    stripe: "",
                    scroll: { x: 2000 },
                    sticky: "",
                    "show-header-scrollbar": "",
                    "auto-header-height": ""
                  }, {
                    bodyCell: _withCtx(({ column, record }) => [
                      (column.type === 'isOrNot')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formatIsOrNot(column, record)), 1))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'oprRoles')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(formatRoles(record.oprRoles)), 1))
                        : _createCommentVNode("", true),
                      (column.type == 'jsonEditor')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (record.component)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: ($event: any) => (openJsonEditor(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("编辑")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    cellEditor: _withCtx(({
                  column,
                  modelValue,
                  save,
                  closeEditor,
                  editorRef
                }) => [
                      (column.type === 'columnType')
                        ? (_openBlock(), _createBlock(_component_a_select, {
                            key: 0,
                            ref: editorRef,
                            bordered: true,
                            value: modelValue.value,
                            style: {"width":"120px"},
                            options: [
                      {
                        value: 'varchar',
                        label: 'varchar'
                      },
                      {
                        value: 'bigint',
                        label: 'bigint'
                      },
                      {
                        value: 'int',
                        label: 'int'
                      },
                      {
                        value: 'char',
                        label: 'char'
                      },
                      {
                        value: 'date',
                        label: 'date'
                      },
                      {
                        value: 'datetime',
                        label: 'datetime'
                      },
                      {
                        value: 'text',
                        label: 'text'
                      }
                    ],
                            open: "",
                            "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                            onBlur: closeEditor,
                            onKeydown: _withKeys(closeEditor, ["esc"]),
                            onClick: _withModifiers(closeEditor, ["stop"])
                          }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                        : (column.type === 'component')
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 1,
                              ref: editorRef,
                              bordered: true,
                              value: modelValue.value,
                              style: {"width":"120px"},
                              options: [
                      {
                        value: 'el-input',
                        label: '文本框'
                      },
                      {
                        value: 'ElSelectExt',
                        label: '下拉框'
                      },
                      {
                        value: 'ElTableExt',
                        label: '表格弹窗选择'
                      },
                      {
                        value: 'el-date-picker',
                        label: '日期框'
                      },
                      {
                        value: 'DynamicJsonForm',
                        label: 'json多数据扩展'
                      }
                    ],
                              open: "",
                              "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                              onBlur: closeEditor,
                              onKeydown: _withKeys(closeEditor, ["esc"]),
                              onClick: _withModifiers(closeEditor, ["stop"])
                            }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                          : (column.type === 'isOrNot')
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 2,
                                ref: editorRef,
                                bordered: true,
                                value: modelValue.value,
                                style: {"width":"120px"},
                                options: [
                      {
                        value: 0,
                        label: '否'
                      },
                      {
                        value: 1,
                        label: '是'
                      }
                    ],
                                open: "",
                                "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                                onBlur: closeEditor,
                                onKeydown: _withKeys(closeEditor, ["esc"])
                              }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown"]))
                            : (column.type === 'oprRoles')
                              ? (_openBlock(), _createBlock(_component_a_select, {
                                  key: 3,
                                  ref: editorRef,
                                  bordered: true,
                                  value: modelValue.value,
                                  style: {"width":"120px"},
                                  options: oprRoles.value,
                                  open: "",
                                  "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                                  onBlur: closeEditor,
                                  onKeydown: _withKeys(closeEditor, ["esc"]),
                                  onClick: _withModifiers(closeEditor, ["stop"])
                                }, null, 8, ["value", "options", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                              : (column.type == 'textarea')
                                ? (_openBlock(), _createBlock(_component_a_textarea, {
                                    key: 4,
                                    ref: editorRef,
                                    bordered: true,
                                    value: modelValue.value,
                                    autosize: "true",
                                    "onUpdate:value": 
              (v) => {
                modelValue.value = v
              }
            ,
                                    onBlur: save,
                                    onKeydown: _withKeys(closeEditor, ["esc"])
                                  }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown"]))
                                : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data-source", "columns"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: preStep
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("上一步")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: translateByOneKey
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("一键生成")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "default",
                    onClick: cancelAndClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "before-leave"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: jsonEditorDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((jsonEditorDialog).value = $event)),
      title: "配置属性",
      width: "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(JsonEditor), {
          ref_key: "jsonEditorRef",
          ref: jsonEditorRef,
          style: { height: '100%' },
          mode: 'text',
          modelValue: currentJsonData.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentJsonData).value = $event)),
          onKeydown: _withKeys(_withModifiers(handleSave, ["ctrl","prevent","stop"]), ["s"])
        }, null, 8, ["modelValue", "onKeydown"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})